import React, { useReducer } from "react";
export var EntityType;
(function (EntityType) {
    EntityType["PERSON"] = "PERSON";
    EntityType["CORPORATION"] = "CORPORATION";
})(EntityType || (EntityType = {}));
export var PepType;
(function (PepType) {
    PepType["NOT_PEP"] = "NOT_PEP";
    PepType["ME"] = "ME";
    PepType["RELATIVE"] = "RELATIVE";
    PepType["COLLEAGUE"] = "COLLEAGUE";
})(PepType || (PepType = {}));
export var PepStatus;
(function (PepStatus) {
    PepStatus["ONGOING"] = "ONGOING";
    PepStatus["ENDED"] = "ENDED";
})(PepStatus || (PepStatus = {}));
export var Role;
(function (Role) {
    Role["HEAD_OF_GOVERNMENT"] = "HEAD_OF_GOVERNMENT";
    Role["MINISTER"] = "MINISTER";
    Role["PARLIMENT_MEMBER"] = "PARLIMENT_MEMBER";
    Role["CENTRAL_BANK_MEMBER"] = "CENTRAL_BANK_MEMBER";
    Role["BOARD_MEMBER_POLITICAL_PARTY"] = "BOARD_MEMBER_POLITICAL_PARTY";
    Role["JUDGE_SUPREME_COURT"] = "JUDGE_SUPREME_COURT";
    Role["JUDGE_OTHER_HIGH_COURT"] = "JUDGE_OTHER_HIGH_COURT";
    Role["REVISION_INSTITUTE"] = "REVISION_INSTITUTE";
    Role["AMBASSADOR"] = "AMBASSADOR";
    Role["MILITARY_OFFICER"] = "MILITARY_OFFICER";
    Role["GOVERNMENT_COMPANY"] = "GOVERNMENT_COMPANY";
    Role["EU_HIGH_RANKING_POSITION"] = "EU_HIGH_RANKING_POSITION";
    Role["HIGH_RANKING_POSITION_INTERNALTIONAL_CORP"] = "HIGH_RANKING_POSITION_INTERNALTIONAL_CORP";
})(Role || (Role = {}));
export var Relation;
(function (Relation) {
    Relation["MARRIED_PARTNER"] = "MARRIED_PARTNER";
    Relation["COLIVING_PARTNER"] = "COLIVING_PARTNER";
    Relation["CHILD"] = "CHILD";
    Relation["PARENT"] = "PARENT";
    Relation["CHILD_MARRIED_PARTNER"] = "CHILD_MARRIED_PARTNER";
    Relation["CHILD_COLIVING_PARTNER"] = "CHILD_COLIVING_PARTNER";
})(Relation || (Relation = {}));
export var BusinessRelation;
(function (BusinessRelation) {
    BusinessRelation["CO_OWNERSHIP"] = "CO_OWNERSHIP";
    BusinessRelation["CLOSE_CONNECTION"] = "CLOSE_CONNECTION";
    BusinessRelation["COMPANY_FOR_PEP"] = "COMPANY_FOR_PEP";
})(BusinessRelation || (BusinessRelation = {}));
export var MilitaryRank;
(function (MilitaryRank) {
    MilitaryRank["GENERAL"] = "GENERAL";
    MilitaryRank["LIEUTENANT_GENERAL"] = "LIEUTENANT_GENERAL";
    MilitaryRank["MAJOR_GENERAL"] = "MAJOR_GENERAL";
    MilitaryRank["ADMIRAL"] = "ADMIRAL";
    MilitaryRank["VICE_ADMIRAL"] = "VICE_ADMIRAL";
    MilitaryRank["REAR_ADMIRAL"] = "REAR_ADMIRAL";
})(MilitaryRank || (MilitaryRank = {}));
export const EMPTY_PEP_STATE = {
    legalEntityType: undefined,
    type: undefined,
    role: undefined,
    country: undefined,
    ended: undefined,
    ambassadorCountry: undefined,
    militaryRank: undefined,
    governmentCompany: undefined,
    governmentCompanyRole: undefined,
    internationalOrganisation: undefined,
    internationalOrganisationRole: undefined,
    relationToPEP: undefined,
    nameOfPEP: undefined,
    birthdayOfPEP: undefined,
    tin: undefined,
    businessRelation: undefined,
    locked: undefined,
    isOngoing: undefined,
    isLocalCountry: undefined,
    ownerName: undefined,
};
export const PepContext = React.createContext({});
export const withPep = (Component) => (props) => (React.createElement(PepContext.Consumer, null, (contextProps) => React.createElement(Component, Object.assign({}, props, contextProps))));
function stateReducer(state, newState) {
    return Object.assign(Object.assign({}, state), newState);
}
export const PepContextProvider = ({ children }) => {
    const [pep, setPep] = useReducer(stateReducer, {});
    return (React.createElement(PepContext.Provider, { value: { state: pep, setState: setPep } }, children));
};
